import client from 'api/client';
import { AxiosRequestConfig } from 'axios';

export function get(id: string, customConfig?: AxiosRequestConfig) {
    return client.get(`/service_provider/${id}`, customConfig);
}
